(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
/* Category toggle (mobile only) */
(function () {
  var toggle = document.querySelector('[data-category-toggle]');
  var nav = document.querySelector('[data-category-list]');
  if (!toggle || !nav) return;

  toggle.addEventListener('click', function () {
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    nav.classList.toggle('ll-collection__category-nav--open');
  });
})();

/* Set featured card image height to match regular card image height */
(function () {
  function setCardHeight() {
    var regular = document.querySelector('.ll-product-card:not(.ll-product-card--featured) .ll-product-card__image');
    if (!regular) return;
    var grid = regular.closest('.ll-collection__grid');
    if (grid) grid.style.setProperty('--ll-card-image-height', regular.offsetHeight + 'px');
  }
  setCardHeight();
  window.addEventListener('resize', setCardHeight);
})();

/* Sort select */
(function () {
  var select = document.querySelector('[data-sort-select]');
  if (!select) return;

  select.addEventListener('change', function () {
    if (!this.value) return;

    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', this.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });
})();

/* Product card add-to-bag wired via assets/ll-product-card-add.js (delegated). */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event"]) return;
  try {
    
(function () {
  var popup = document.getElementById('ll-event-form-popup');
  if (!popup) return;

  var backdrop = document.querySelector('[data-event-form-backdrop]');
  var trigger = document.querySelector('[data-event-form-trigger]');
  var closeBtn = popup.querySelector('[data-event-form-close]');
  var form = popup.querySelector('form');
  var posted = popup.querySelector('[data-event-form-posted]');
  var hasErrors = popup.querySelector('[data-event-form-errors]');
  var activeTrigger = null;

  function openPopup(originTrigger) {
    activeTrigger = originTrigger || null;
    popup.hidden = false;
    backdrop.hidden = false;
    document.documentElement.style.overflow = 'hidden';

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        popup.classList.add('ll-event-form--open');
        backdrop.classList.add('ll-event-form-backdrop--visible');
      });
    });

    var firstInput = popup.querySelector('input[type="text"], input[type="email"], textarea');
    if (firstInput) firstInput.focus();
    popup.addEventListener('keydown', handleKeydown);
  }

  function closePopup() {
    popup.classList.remove('ll-event-form--open');
    backdrop.classList.remove('ll-event-form-backdrop--visible');
    document.documentElement.style.overflow = '';
    popup.removeEventListener('keydown', handleKeydown);

    popup.addEventListener('transitionend', function onEnd() {
      popup.removeEventListener('transitionend', onEnd);
      popup.hidden = true;
      backdrop.hidden = true;
      if (activeTrigger) {
        activeTrigger.focus();
        activeTrigger = null;
      }
    });

    setTimeout(function () {
      if (!popup.hidden && !popup.classList.contains('ll-event-form--open')) {
        popup.hidden = true;
        backdrop.hidden = true;
      }
    }, 350);
  }

  function handleKeydown(e) {
    if (e.key === 'Escape') {
      closePopup();
      return;
    }
    if (e.key !== 'Tab') return;

    var focusable = popup.querySelectorAll(
      'input:not([type="hidden"]):not([disabled]), textarea:not([disabled]), button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'
    );
    if (focusable.length === 0) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  /* Prepend event title and URL to the message body on submit (idempotent) */
  if (form) {
    form.addEventListener('submit', function () {
      var titleEl = form.querySelector('[data-event-title]');
      var urlEl = form.querySelector('[data-event-url]');
      var msgEl = form.querySelector('[data-event-form-message]');
      if (!titleEl || !urlEl || !msgEl) return;
      var marker = 'Event: ' + titleEl.value;
      if (msgEl.value.indexOf(marker) === 0) return;
      var prefix = marker + '\nURL: ' + urlEl.value + '\n\n';
      msgEl.value = prefix + msgEl.value;
    });
  }

  if (trigger) {
    trigger.addEventListener('click', function () {
      openPopup(trigger);
    });
  }

  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  if (backdrop) backdrop.addEventListener('click', closePopup);

  /* Auto-open the popup if the form just posted (success or errors) */
  if (posted || hasErrors) {
    openPopup(trigger);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  const header = document.querySelector('[data-header]');
  if (!header) return;

  /* ---- Hamburger toggle ---- */
  const panel = document.getElementById('ll-hamburger-panel');
  const openBtn = header.querySelector('[data-hamburger-open]');
  const closeBtn = panel ? panel.querySelector('[data-hamburger-close]') : null;

  function openHamburger() {
    if (!panel) return;
    panel.hidden = false;
    /* Two RAFs let the browser apply hidden=false before the transition starts. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        panel.classList.add('ll-hamburger--open');
      });
    });
    openBtn.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    /* Focus the close button */
    if (closeBtn) closeBtn.focus();
    /* Trap focus */
    panel.addEventListener('keydown', trapFocus);
  }

  function closeHamburger() {
    if (!panel) return;
    panel.classList.remove('ll-hamburger--open');
    panel.addEventListener('transitionend', function onEnd() {
      panel.removeEventListener('transitionend', onEnd);
      panel.hidden = true;
    });
    openBtn.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    panel.removeEventListener('keydown', trapFocus);
    openBtn.focus();
  }

  function trapFocus(e) {
    if (e.key === 'Escape') {
      closeHamburger();
      return;
    }
    if (e.key !== 'Tab') return;

    const focusable = panel.querySelectorAll(
      'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  if (openBtn) openBtn.addEventListener('click', openHamburger);
  if (closeBtn) closeBtn.addEventListener('click', closeHamburger);

  /* ---- Bag count update ---- */
  function pulseBagCount(el) {
    el.classList.remove('ll-pulse');
    /* Force reflow so the animation restarts on consecutive updates. */
    void el.offsetWidth;
    el.classList.add('ll-pulse');
    el.addEventListener('animationend', function onEnd() {
      el.removeEventListener('animationend', onEnd);
      el.classList.remove('ll-pulse');
    });
  }

  function updateBagCount(count) {
    document.querySelectorAll('[data-bag-count]').forEach(function (el) {
      el.textContent = count;
      pulseBagCount(el);
    });
  }

  function fetchBagCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) { updateBagCount(cart.item_count); })
      .catch(function () { /* silent fail */ });
  }

  /* Listen for Shopify cart events (theme-standard custom events) */
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && typeof e.detail.item_count !== 'undefined') {
      updateBagCount(e.detail.item_count);
    } else {
      fetchBagCount();
    }
  });

  /* Expose a global helper for other scripts to trigger bag count refresh */
  window.llUpdateBagCount = fetchBagCount;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ll-homepage-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  var carousel = document.querySelector('[data-carousel]');
  if (!carousel) return;

  var slides = carousel.querySelectorAll('[data-slide]');
  var count = slides.length;
  if (count < 2) return;

  var cadence = parseInt(carousel.dataset.cadence, 10) * 1000 || 6000;
  var current = 0;
  var timer = null;
  var paused = false;

  /* Respect prefers-reduced-motion: auto-advance is skipped, click and
     swipe still work. Listen for changes so the user can flip the OS
     setting at runtime. */
  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  motionQuery.addEventListener('change', function (e) {
    if (e.matches) {
      stop();
    } else if (!paused) {
      start();
    }
  });

  function resolveColour(value) {
    return value === 'black' ? '#000000' : '#FFFFFF';
  }

  function setPageColour(slide) {
    var raw = slide.dataset.logoColour || 'auto';
    var hex = resolveColour(raw);
    document.body.style.setProperty('--ll-color-text', hex);
    document.body.style.setProperty('--ll-color-text-muted', hex === '#FFFFFF'
      ? 'oklch(from #FFFFFF l c h / 0.4)'
      : 'oklch(from #000000 l c h / 0.4)'
    );
  }

  function goTo(index) {
    slides[current].classList.remove('ll-carousel__slide--active');
    slides[current].setAttribute('aria-hidden', 'true');

    current = index;

    slides[current].classList.add('ll-carousel__slide--active');
    slides[current].removeAttribute('aria-hidden');

    setPageColour(slides[current]);
  }

  /* Infinite loop: wraps from last slide back to first */
  function next() {
    goTo((current + 1) % count);
  }

  function prev() {
    goTo((current - 1 + count) % count);
  }

  function start() {
    if (timer) return;
    if (motionQuery.matches) return;
    timer = setInterval(next, cadence);
  }

  function stop() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  /* Pause on focus within the header (ticker link, nav links) */
  var header = document.querySelector('[data-header]');
  if (header) {
    header.addEventListener('focusin', function () {
      paused = true;
      stop();
    });
    header.addEventListener('focusout', function () {
      paused = false;
      start();
    });
  }

  /* Pause on page visibility change */
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      stop();
    } else if (!paused) {
      start();
    }
  });

  /* Click anywhere on the active slide advances to the next */
  slides.forEach(function (slide) {
    slide.addEventListener('click', function () {
      next();
    });
  });

  /* Horizontal touch swipe: left -> next, right -> previous. Threshold 30px. */
  var touchStartX = null;
  carousel.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1) return;
    touchStartX = e.touches[0].clientX;
  }, { passive: true });

  carousel.addEventListener('touchend', function (e) {
    if (touchStartX === null) return;
    var dx = e.changedTouches[0].clientX - touchStartX;
    touchStartX = null;
    if (Math.abs(dx) < 30) return;
    if (dx < 0) next(); else prev();
  }, { passive: true });

  start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
(function () {
var viewport = document.querySelector('.ll-product__gallery-viewport');
if (!viewport) return;

var images = viewport.querySelectorAll('.ll-product__gallery-image');
var dots = viewport.closest('.ll-product__gallery')
  ?.querySelectorAll('.ll-product__gallery-dot');
if (images.length < 2 || !dots) return;

var current = 0;
var isSliding = false;
var DURATION = 350;

/* direction: 1 = forward (slide left), -1 = backward (slide right) */
function showImage(index, direction) {
  if (isSliding || index === current) return;
  isSliding = true;

  var outgoing = images[current];
  var incoming = images[index];

  /* Position incoming off-screen, no transition */
  incoming.classList.remove('ll-product__gallery-image--sliding');
  incoming.classList.remove('ll-product__gallery-image--active');
  incoming.style.transform = direction > 0 ? 'translateX(100%)' : 'translateX(-100%)';

  /* Force reflow so the browser registers the start position */
  incoming.offsetHeight;

  /* Enable transitions on both */
  outgoing.classList.add('ll-product__gallery-image--sliding');
  incoming.classList.add('ll-product__gallery-image--sliding');

  /* Slide both */
  outgoing.style.transform = direction > 0 ? 'translateX(-100%)' : 'translateX(100%)';
  incoming.style.transform = 'translateX(0)';

  /* Update dots */
  dots[current].classList.remove('ll-product__gallery-dot--active');
  dots[current].setAttribute('aria-selected', 'false');
  dots[index].classList.add('ll-product__gallery-dot--active');
  dots[index].setAttribute('aria-selected', 'true');

  /* Update active class and clean up after transition */
  outgoing.classList.remove('ll-product__gallery-image--active');
  incoming.classList.add('ll-product__gallery-image--active');
  current = index;

  setTimeout(function () {
    outgoing.classList.remove('ll-product__gallery-image--sliding');
    incoming.classList.remove('ll-product__gallery-image--sliding');
    isSliding = false;
  }, DURATION);
}

/* Dot navigation */
dots.forEach(function (dot) {
  dot.addEventListener('click', function () {
    var index = parseInt(this.dataset.index, 10);
    if (index === current) return;
    var direction = index > current ? 1 : -1;
    showImage(index, direction);
  });
});

/* Shared navigation helpers (infinite loop) */
function goNext() {
  var next = current < images.length - 1 ? current + 1 : 0;
  showImage(next, 1);
}

function goPrev() {
  var prev = current > 0 ? current - 1 : images.length - 1;
  showImage(prev, -1);
}

function handleSwipe(diff) {
  if (Math.abs(diff) < 50) return;
  if (diff < 0) goNext();
  else goPrev();
}

/* Track whether the current pointer interaction was a drag/swipe,
   so the trailing click event can be suppressed and a plain click
   (no movement) advances the gallery. */
var pointerMoved = false;
var MOVE_THRESHOLD = 5;

/* Touch swipe */
var touchStartX = 0;

viewport.addEventListener('touchstart', function (e) {
  touchStartX = e.touches[0].clientX;
  pointerMoved = false;
}, { passive: true });

viewport.addEventListener('touchmove', function (e) {
  if (Math.abs(e.touches[0].clientX - touchStartX) > MOVE_THRESHOLD) pointerMoved = true;
}, { passive: true });

viewport.addEventListener('touchend', function (e) {
  handleSwipe(e.changedTouches[0].clientX - touchStartX);
}, { passive: true });

/* Mouse drag (desktop) */
var mouseStartX = 0;
var isDragging = false;

viewport.addEventListener('mousedown', function (e) {
  mouseStartX = e.clientX;
  isDragging = true;
  pointerMoved = false;
  e.preventDefault();
});

viewport.addEventListener('mousemove', function (e) {
  if (isDragging) {
    if (Math.abs(e.clientX - mouseStartX) > MOVE_THRESHOLD) pointerMoved = true;
    e.preventDefault();
    return;
  }
  var rect = viewport.getBoundingClientRect();
  var isPrev = e.clientX < rect.left + rect.width / 2;
  viewport.classList.toggle('ll-product__gallery-viewport--prev', isPrev);
  viewport.classList.toggle('ll-product__gallery-viewport--next', !isPrev);
});

viewport.addEventListener('mouseup', function (e) {
  if (!isDragging) return;
  isDragging = false;
  handleSwipe(e.clientX - mouseStartX);
});

viewport.addEventListener('mouseleave', function () {
  isDragging = false;
  viewport.classList.remove('ll-product__gallery-viewport--prev');
  viewport.classList.remove('ll-product__gallery-viewport--next');
});

/* Prevent native image drag */
viewport.addEventListener('dragstart', function (e) {
  e.preventDefault();
});

/* Click / tap on the image: right half advances, left half goes back (looped).
   Skipped after a drag or swipe so it doesn't double-trigger. */
viewport.addEventListener('click', function (e) {
  if (pointerMoved) {
    pointerMoved = false;
    return;
  }
  var rect = viewport.getBoundingClientRect();
  if (e.clientX < rect.left + rect.width / 2) goPrev();
  else goNext();
});

/* Keyboard arrow keys */
document.addEventListener('keydown', function (e) {
  if (e.key === 'ArrowRight') { e.preventDefault(); goNext(); }
  if (e.key === 'ArrowLeft') { e.preventDefault(); goPrev(); }
});
})();

/* Variant picker */
(function () {
var info = document.querySelector('.ll-product__info');
if (!info) return;

var variantsScript = document.querySelector('[data-product-variants]');
var selects = info.querySelectorAll('[data-option-index]');
if (!variantsScript || !selects.length) return;

var variants;
try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

var idInput = info.querySelector('input[name="id"]');
var priceEl = info.querySelector('[data-product-price]');

function getSelectedOptions() {
  var opts = [];
  selects.forEach(function (sel) {
    opts[parseInt(sel.dataset.optionIndex, 10)] = sel.value;
  });
  return opts;
}

function findVariant(opts) {
  return variants.find(function (v) {
    return v.options.every(function (val, idx) { return val === opts[idx]; });
  });
}

function updateForVariant(variant) {
  if (!variant) return;
  if (idInput) idInput.value = variant.id;
  if (priceEl) priceEl.innerHTML = variant.price_formatted;
  info.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant: variant } }));
}

selects.forEach(function (sel) {
  sel.addEventListener('change', function () {
    updateForVariant(findVariant(getSelectedOptions()));
  });
});
})();

/* Gift wrap toggle visibility */
(function () {
var info = document.querySelector('.ll-product__info');
if (!info) return;
var toggle = info.querySelector('[data-gift-wrap-toggle]');
if (!toggle) return;
var checkbox = toggle.querySelector('[data-gift-wrap-checkbox]');

info.addEventListener('variant:changed', function (e) {
  var variant = e.detail && e.detail.variant;
  if (!variant) return;
  if (variant.requires_shipping) {
    toggle.hidden = false;
  } else {
    toggle.hidden = true;
    if (checkbox) checkbox.checked = false;
  }
});
})();

/* Add-to-bag lives in assets/ll-product-add.js, loaded from layout/theme.liquid.
   Keeping it out of this bundle means a throw in the gallery code above cannot
   stop the form from being intercepted. */

  } catch(e) { console.error(e); }
})();
})();
